import OAuth2ImplicitGrantAuthenticator from 'ember-simple-auth/authenticators/oauth2-implicit-grant';
import { getOwner } from '@ember/owner';
import { timeZone } from 'tio-common/utils/date/time-zone';
import { generateRequestId } from 'tio-common/utils/request-id';
import ENV from 'tio-employee/config/environment';
import type SessionService from 'tio-employee/services/session';

export default class Saml extends OAuth2ImplicitGrantAuthenticator {
  async authenticate(hash: { access_token: string }) {
    await this.#validateToken(hash.access_token);
    // @ts-expect-error: ESA has types and this now complains
    return await super.authenticate(hash);
  }

  async #validateToken(token: string) {
    let response, error;

    if (token) {
      const publicKey = (getOwner(this)?.lookup('service:session') as SessionService | undefined)
        ?.publicKey;
      try {
        response = await fetch(`${ENV.apiHost}/me`, {
          headers: {
            'x-api-key': ENV.apiKey,
            ...(publicKey && { 'x-auth-key': publicKey }),
            'tio-auth-token': token,
            Accept: 'application/vnd.api+json',
            'Time-Zone': timeZone(),
            'X-Request-Id': generateRequestId(),
          },
        });
      } catch (e) {
        error = e.message;
      }
    }

    if (!token) {
      error = 'missing token';
      // @ts-expect-error: not sure
    } else if (response?.status >= 500) {
      error = 'server error';
      // @ts-expect-error: not sure
    } else if (response?.status >= 400) {
      error = 'invalid token';
    }

    if (error) {
      throw new Error(`Could not authenticate using SAML: ${error}`);
    } else {
      return true;
    }
  }
}
